import type { AnnounceImageVariant as GQLType } from '../generated/checkout.graphql';
import { take } from '../util/takePayload';

export type AnnounceImageVariant = {
  variant: string;
  src: string;
};

export const fromGql = (gqlItem: GQLType): AnnounceImageVariant =>
  take(gqlItem, 'variant', 'src') as AnnounceImageVariant;
export const fromGqlCollection = (gqlItems?: GQLType[] | null) => (gqlItems ? gqlItems.map(fromGql) : []);
